import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fromCurrency',
  standalone: true
})
export class FromCurrencyPipe implements PipeTransform {

  public transform(val: string): number {
    return val.fromCurrency();
  }
}
